import Reflux from 'reflux';
import storeUtils from '../../utils/store';
import filtersActions from '../../actions/edpfilters';
import {stringArrayEqual} from '../../utils/utils';

export default class EdpFiltersStore extends Reflux.Store {
  static id = 'edpfilters';

  constructor () {
    super();
    this.config = {
      bsb: null
    };

    this.state = {
      prices:          [], // raw data from server
      priceTypes:      {}, // raw data from server
      priceCategories: {}, // raw data from server
      ticketLimit:     1,  // data from config
      areaNames:       {
        levels:   {},
        sections: {}
      },
      typesToCategories: {},
      categoriesToTypes: {},
      activeCategory:         null, // for the map, it filters out the sections
      activePriceTypeIds:     [],   // parsed from the priceType.qty
      activePriceCategoryIds: [],   // parsed from the active Price Types
      ticketCount:            0,    // here we parse the current data and add some recap info
      errors:                 [],   // here we keep track of the current errors
      chargeRange:            ''
    };

    this.load();

    this.listenTo(filtersActions.updatePriceTypeQty, 'updatePriceTypeQty');
    this.listenTo(filtersActions.updateActiveCategory, 'updateActiveCategory');
  }

  load () {
    const eventPrices = storeUtils.get('event_prices');
    const eventConfig = storeUtils.get('event_config');

    const data = {
      config: eventConfig,
      ticketLimit: eventConfig.ticketLimit,
      priceTypes: eventPrices.priceTypes || {},
      priceCategories: eventPrices.priceCategories || {},
      prices: eventPrices.prices || [],
      areaNames: eventPrices.areaNames,
      chargeRange: eventPrices.chargeRange
    };

    /**
     * price.priceCategory comes from the server as a number
     * priceCategories.key is a string
     * when comparing
     */
    data.prices = data.prices.map(price => {
      price.priceCategory = price.priceCategory.toString();
      price.priceType = price.priceType.toString();
      return price;
    });

    // loop over the prices and add
    data.prices.forEach(function (price) {
      var priceType = data.priceTypes[price.priceType];
      var priceCategory = data.priceCategories[price.priceCategory];

      priceType.availablePriceCategories = priceType.availablePriceCategories || [];
      priceType.availablePriceCategories.push(price.priceCategory);

      priceCategory.availablePriceTypes = priceCategory.availablePriceTypes || [];
      priceCategory.availablePriceTypes.push(price.priceType);
    }, this);

    this.setState(data);

    this.parseActivePrices();
  }

  updatePriceTypeQty (priceTypeId, activeQuantity) {
    if (this.state.priceTypes[priceTypeId] !== undefined) {
      this.setState({
        priceTypes: {
          ...this.state.priceTypes,
          [priceTypeId]: {
            ...this.state.priceTypes[priceTypeId],
            quantity: activeQuantity
          }
        }
      });
      this.done();
    }
  }

  updateActiveCategory (priceTypeCategoryId) {
    // only trigger update if it changes
    if (this.state.activeCategory !== priceTypeCategoryId) {
      this.setState({activeCategory: priceTypeCategoryId});
    }
    this.done();
  }

  /**
   *
   *  warning types:
   *  1.  W-AS  – Adjacent  Seat Warning
   *  2.  W-TN  – Ticket Naming Error // TODO, confirm the name
   *
   *  error types
   *  1.  E-TL  – Ticket Limit Error
   *  2.  E-SB  – Seat Block Error
   *  3.  E-PTL  – Price Type Error // TODO, confirm what this is
   *  4.  E-NA  – No Availability Error
   *
   * @param {!string} errCode Error Code to add to the activeError list
   */
  setError (errCode) {
    const errors = [...this.state.errors];
    // TODO, add logic of error prioritisation here?
    switch (errCode) {
      case 'W-AS':
        errors.push({
          code:    'W-AS',
          type:    'warning',
          message: 'Adjacent seat warning'
        });
        break;
      case 'E-TL':
        errors.push({
          code:    'E-TL',
          type:    'error',
          message: 'Ticket Limit Exceeded'
        });
        break;
      case 'E-SB':
        // TODO, construct a better error message
        errors.push({
          code:    'E-SB',
          type:    'error',
          message: 'Tickets of these types can only be seated in blocks of ' + this.config.bsb.qty
        });
        break;
    }
    this.setState({errors: errors});
  }

  // HELPER PARSERS
  //----------------------------------------------------------------

  /**
   * This function loops over the priceTypes and
   * finds the one that have a quantity greater than zero
   * In the mean time it also counts the quantity selected
   */
  parseActivePrices () {
    var priceTypeIds = [];
    var priceCategoryIds = [];
    var count = 0;

    Object.keys(this.state.priceTypes).forEach(function (priceTypeId) {
      var priceType = this.state.priceTypes[priceTypeId];
      if (priceType.quantity > 0) {
        count += +priceType.quantity;
        priceTypeIds.push(priceTypeId);
      }
    }, this);

    this.setState({
      ticketCount: count,
      activePriceTypeIds: priceTypeIds
    });

    // check that the ticket count does not exceed the ticketlimit
    if (this.state.ticketCount > this.state.ticketLimit) {
      this.setError('E-TL'); // E-TL – Ticket Limit Error
    }

    // if we have active priceTypes, find the categories that have all these priceTypes
    if (priceTypeIds.length) {
      priceCategoryIds = Object.keys(this.state.priceCategories).filter(priceCategoryId => {
        // test that all priceTypes are contained in this category
        return priceTypeIds.every(
          priceTypeId => this.state.priceCategories[priceCategoryId].availablePriceTypes.indexOf(priceTypeId) !== -1
        );
      });
    }

    this.setState({
      activePriceCategoryIds: priceCategoryIds
    });
  }

  detectAllocationSplit () {
    // get the configuration for the biggest seat block
    var bsb = this.config.bsb;

    if (bsb && bsb.priceTypes && bsb.priceTypes.length && bsb.qty) {
      // check we are in the same configuration as the server
      if (stringArrayEqual(bsb.priceTypes, this.state.activePriceTypeIds) && this.state.ticketCount > bsb.qty) {
        this.setError('E-SB');
      }
    }

    // here we are in a multi priceTypes situation
    if (this.state.activePriceTypeIds.length > 1 && this.state.isAdjacentSeatsMode) {
      var firstPriceTypeId = this.state.activePriceTypeIds[0];
      var firstPriceType = this.state.priceTypes[firstPriceTypeId];
      var blockingCodes = firstPriceType.blockingCodes;
      var isAllocationSplit = false;

      this.state.activePriceTypeIds.forEach(function (priceTypeId, idx) {
        if (idx === 0) {
          return;
        }

        var priceType = this.state.priceTypes[priceTypeId];

        // check that the blocking codes are the same
        if (!isAllocationSplit && !stringArrayEqual(blockingCodes, priceType.blockingCodes)) {
          // oh oh, not same blocking codes, probably will not be able to seat together
          isAllocationSplit = true;
        }
      });

      // if there aren't enough minCommonPriceTypeLocations ('BA' is always there, so compare to 1 not 0) or..
      // if isAllocationSplit because of blocking codes
      if (isAllocationSplit) {
        this.setError('W-AS');
      }
    }
  }

  done () {
    // clean errors first
    this.setState({ errors: [] });
    this.parseActivePrices();
    this.detectAllocationSplit();
  }
}



// WEBPACK FOOTER //
// ./frontend/react/stores/edpfilters/index.js